
module.exports = {
  // TODO: change your profile information here
  name: "Milind Phalke",
  greeting: "Hey 👋",
  greetingDescription: "I'm Milind Phalke and I'm currently pursuing B.Tech in Computer Science!",
  githubUrl: "https://github.com/milind2000",
  linkedinUrl: "https://www.linkedin.com/in/milind-phalke-4497bb174/",
  cvLink: "https://drive.google.com/file/d/1AVEEaa27_vzr2L6FdMf4jKJ-o7ZQhYgk/view?usp=sharing",
};
